import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { LocationGroup, LocationGroupDialogData } from '@core/interfaces';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { sentry } from 'sentry';
import { LocationsGroupsService } from './../services/locations-groups-resolver.service';

@Component({
  selector: 'app-dialog-locations-groups',
  templateUrl: './dialog-locations-groups.component.html',
  styleUrls: ['./dialog-locations-groups.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogLocationsGroupsComponent {
  public locationGroupForm: FormGroup;
  public locationGroup: LocationGroup;
  public isViewMode: boolean;

  public isInvalidForm = true;
  public isSaving = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LocationGroupDialogData,
    public matDialogRef: MatDialogRef<DialogLocationsGroupsComponent>,
    private locationsGroupsService: LocationsGroupsService,
    private customMessageService: CustomMessagesService,
    private progressBar: FuseProgressBarService,
  ) {
    this.locationGroup = this.data.locationGroup;
    this.isViewMode = this.data.isViewMode;
  }


  public getForm(form): void {
    this.locationGroupForm = form;
    this.isInvalidForm = this.locationGroupForm.invalid;
  }

  public async onArchivedClick(archived: boolean): Promise<void> {
    await this.saveLocationGroup({
      ...this.locationGroupForm.value,
      archived
    });
  }

  public async onSaveClick(): Promise<void> {
    await this.saveLocationGroup(this.locationGroupForm.value);
  }

  private async saveLocationGroup(locationsGroupsInput): Promise<void> {
    this.progressBar.show();
    this.isSaving = true;
    try {
      await this.locationsGroupsService.save(this.locationGroup.id, locationsGroupsInput);

      if (locationsGroupsInput.archived) {
        this.locationGroup.archived = locationsGroupsInput.archived;
      }

      this.customMessageService.success('LOCATIONS_GROUPS.SUCCESS_MESSAGE');
      this.matDialogRef.close({ reload: true });
    } catch (err) {
      const code = getErrorCode(err);
      if (code === 'location_group_name_duplicated') {
        this.locationGroupForm.get('name').setErrors({
          'location_group_name_duplicated': true
        });

        return;
      }

      this.customMessageService.error('LOCATIONS_GROUPS.ERROR_MESSAGE');
      sentry.captureException(err);
    } finally {
      this.progressBar.hide();
      this.isSaving = false;
    }
  }
}
